'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildMessageWithStatus = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _propertyValues = require('../../lib/propertyValues');

var _buildMessage = require('./buildMessage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildMessageWithStatus = exports.buildMessageWithStatus = function buildMessageWithStatus(status) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return (0, _pipe2.default)((0, _propertyValues.enforcePartialValues)({ descriptor: { status: status } }), _buildMessage.buildMessage)(props);
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/factories/PubNubMessageFactory/buildMessageWithStatus.js
// module id = 171
// module chunks = 2 3